import { ACDSessionManager, HttpUtilService, HttpClient } from '@nice-devone/core-sdk';
import { logger } from '../../../utils/logger';
import { resolveTeamId } from './team-id-resolver';
import { mapUnavailableCodesResponse, type UnavailableCode } from './unavailable-codes-mapper';

export function subscribeToUnavailableCodes(callback: (codes: unknown) => void): {
  unsubscribe: () => void;
} {
  const acdSession = ACDSessionManager.instance;
  const subscription = acdSession.agentUpdateUnavailableCodeSubject.subscribe(callback);
  return {
    unsubscribe: () => subscription.unsubscribe(),
  };
}

/**
 * Fetch unavailable codes from CXone API
 *
 * API: GET /InContactAPI/services/v23.0/teams/{teamId}/unavailable-codes
 */
export async function fetchUnavailableCodes(): Promise<UnavailableCode[]> {
  logger.debug('[CXone SDK] Fetching unavailable codes...');

  const acdSession = ACDSessionManager.instance;
  const baseUrl = acdSession.cxOneConfig?.acdApiBaseUri;
  const authToken = acdSession.accessToken;

  if (!baseUrl || !authToken) {
    logger.error('[CXone SDK] Missing config for fetchUnavailableCodes');
    return [];
  }

  const utilService = new HttpUtilService();
  const reqInit = utilService.initHeader(authToken, 'application/json');
  const teamId = await resolveTeamId(baseUrl, reqInit);

  if (!teamId) {
    logger.error('[CXone SDK] Could not determine teamId for unavailable codes');
    return [];
  }

  const url = `${baseUrl}/InContactAPI/services/v23.0/teams/${teamId}/unavailable-codes`;
  logger.debug('[CXone SDK] fetchUnavailableCodes URL:', url);

  try {
    const response = await HttpClient.get(url, reqInit);
    logger.debug('[CXone SDK] fetchUnavailableCodes response:', response);

    const data = response?.data || response;
    const mappedCodes = mapUnavailableCodesResponse(data);

    logger.debug('[CXone SDK] Mapped unavailable codes:', mappedCodes);
    return mappedCodes;
  } catch (error) {
    logger.error('[CXone SDK] fetchUnavailableCodes failed:', error);
    return [];
  }
}
